import React, { useState, useEffect } from 'react';
import NavLinks from '../navigation/NavLinks';
import { Link } from 'react-router-dom';
import SocialIcons from '../common/SocialIcons';
import SubscribeModal from '../common/SubscribeModal';
import ContactModal from '../common/ContactModal';
import { useLanguage } from "../common/LanguageContext";
import '../../styles/header.css';

function HeaderDesktop() {
  const { switchLanguage, language } = useLanguage();
  const { translations } = useLanguage();
  const [isSubscribeOpen, setIsSubscribeOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isTop, setIsTop] = useState(true); // В самом верху страницы
  const [showHeader, setShowHeader] = useState(true); // Показывать/скрывать меню
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 1024) {
        const currentScroll = window.scrollY;

        // Проверяем, находится ли пользователь в самом верху страницы
        setIsTop(currentScroll <= 50);

        // Управляем видимостью меню
        if (currentScroll > scrollPosition && currentScroll > 60) {
          setShowHeader(false); // Скрыть меню при скролле вниз
        } else {
          setShowHeader(true); // Показать меню при скролле вверх
        }

        setScrollPosition(currentScroll);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollPosition]);

  return (
    <>
      <header
        className={`desktop-header ${isTop ? 'transparent' : 'scrolled'} ${
          showHeader ? 'visible' : 'hidden'
        }`}
      >
        <div className="header-container">
          <Link key="MainMenu" to="/">
            <div className="desktop-header-logo">
              <img src="/NIRIVS_logo.svg" alt="NIRIVS Logo" className="logo-image" />
            </div>
          </Link>
          <nav className="desktop-header-nav">
            <NavLinks />
          </nav>
          <div className="desktop-header-actions">
            <button className="header-button" onClick={() => setIsSubscribeOpen(true)}>
              {translations.menuText.buttons.subscribeBtn}
            </button>
            <button className="header-button" onClick={() => setIsContactOpen(true)}>
              {translations.menuText.buttons.msgUs}
            </button>
            <SocialIcons isTransparent={isTop} />
            <div className="language-switch">
              <button
                className={`language-btn ${language === 'ru' ? 'active' : ''}`}
                onClick={() => switchLanguage('ru')}
              >
                RU
              </button>
              <button
                className={`language-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
        </div>
      </header>
      {isSubscribeOpen && (
        <>
          <div className="overlay" onClick={() => setIsSubscribeOpen(false)}></div>
          <SubscribeModal onClose={() => setIsSubscribeOpen(false)} />
        </>
      )}
      {isContactOpen && (
        <>
          <div className="overlay" onClick={() => setIsContactOpen(false)}></div>
          <ContactModal onClose={() => setIsContactOpen(false)} />
        </>
      )}
    </>
  );
}

export default HeaderDesktop;
